import React from "react";

const AddUserConfirmationModal = ({
  show,
  newReceipentsCount,
  selectedLanguage,
  onConfirm,
}) => {
  if (!show) return null;

  return (
    <div className="modalCus" id="myModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="d-flex justify-content-center flex-column mb-3 text-center my-2">
              <div className="mb-3">
                <img
                  src="assets/img/icons/check.png"
                  alt=""
                  className="h-80p"></img>
              </div>
              <h4 className="text-danger fw-bold font-22" htmlFor="">
                {selectedLanguage.LstLanguageCodes.UI_ReadersAdded}
              </h4>
              <p
                className="w-100 f-w550 mb-2"
                style={{ display: "content" }}>
                {newReceipentsCount > 1 &&
                  selectedLanguage.LstLanguageCodes.UI_2NewAutherizedReader.replace(
                    "{0}",
                    newReceipentsCount
                  )}
                {newReceipentsCount == 1 &&
                  selectedLanguage.LstLanguageCodes.UI_1NewAutherizedReader.replace(
                    "{0}",
                    newReceipentsCount
                  )}
              </p>
            </div>
            <div className="d-flex justify-content-center mb-2">
              <button
                type="button"
                className="btn btn-primary px-5"
                onClick={(e) => onConfirm()}>
                {selectedLanguage.LstLanguageCodes.UI_OK}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserConfirmationModal;
